// dependencies
import React from "react";
import ReactDOM from "react-dom";

// components
import Card from "../../components.smart/EmployeeCard";

const EmployeeCard = () => {
	const rootElement = document.getElementById("employee-card");
	const employeeID = rootElement.getAttribute("data-user-id");

	const content = <Card employeeID={employeeID} />;

	return ReactDOM.createPortal(content, rootElement);
};

export default EmployeeCard;
